var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"ml-3 pt-0 pb-12"},[_c('div',{staticClass:"subtitle-1"},[_vm._v(_vm._s(_vm.vString))])])}
var staticRenderFns = []

export { render, staticRenderFns }